import axios from 'axios';
import {toast} from "vue3-toastify";

const websiteModule = {
    namespaced: true,
    state() {
        return {
            policies: [],
            policyLoading: true,
            blogs: [],
            blogsLoading: false,
            pagination: null,
            blogsDetail: [],
            loader : false,
            blogCommentsloader:false,
            blogComments:[],
            replyLoader:false,
            blogCategories:[],
            blogPagination:null,
            morePage: [],
            loadingMorePage: false,
        };
    },

    mutations: {
        SET_POLICY_DATA(state, data) {
            state.policies = data;
        },
        SET_POLICY_LOADING(state, loading) {
            state.policyLoading = loading;
        },
        SET_BLOGS_DATA(state, data) {
            state.blogs = data;
        },
        SET_BLOGS_DATA_LOADING(state, loading) {
            state.blogsLoading = loading;
        },
        SET_PAGINATION(state, page) {
            state.pagination = page;
        },
        SET_BLOGS_DETAILS(state, data){
            state.blogsDetail = data
        },
        SET_COMMENT_LOADER(state ,loader){
            state.loader = loader;
        },
        SET_BLOG_COMMENT_LOADER(state,loader){
            state.blogCommentsloader = loader;
        },
        SET_BLOG_COMMENT_DATA(state, comments) {
            state.blogComments = comments; // Ensure Vue reactivity
        },
        SET_BLOG_REPLY_LOADER(state,loader){
            state.replyLoader = loader;
        },
        ADD_REPLY(state, { commentId, reply }) {
            let comment = state.blogComments.find(comment => comment.id === commentId);
            if (comment) {
                comment.replies = [...comment.replies, reply];
            }
        },
        SET_BLOG_CATEGORIES(state , data){
            state.blogCategories = data;
        },
        SET_BLOG_PAGINATION(state,pagination){
            state.blogPagination = pagination;
        },
        SET_MORE_PAGE(state, data) {
            state.morePage = data;
        },
        SET_MORE_PAGE_LOADING(state, loading) {
            state.loadingMorePage = loading;
        },
        
    },
    actions: {
        async fetchPolicyData({ commit }) {
            window.scrollTo(0, 0);
            let url = `/api/pages`;
            try {
                commit('SET_POLICY_LOADING', true);
                let response = await axios.get(url);
                // console.log('pages', response.data)
                commit('SET_POLICY_DATA', response.data);
                commit('SET_POLICY_LOADING', false);
            } catch (error) {
                console.log(error);
                commit('SET_POLICY_LOADING', false);
            }
        },

            async fetchBlogs({ commit }, {page , catId = null}) {
                window.scrollTo(0, 0);
                const url = `/api/blogs?page=${page}${catId ? `&category=${catId}` : ''}`;

                try {
                    commit('SET_BLOGS_DATA_LOADING', true);
                    const response = await axios.get(url);
                    commit('SET_BLOGS_DATA', response.data.data);
                    commit('SET_BLOG_PAGINATION', response.data);
                    // console.log("BLOG DATA", response.data);
                    commit('SET_BLOGS_DATA_LOADING', false);
                } catch (errors) {
                    console.log(errors);
                    commit('SET_BLOGS_DATA_LOADING', false);
                }
            },

        async fetchBlogsDetail({commit}, slug){
            window.scrollTo(0, 0);
            const url =  `/api/blog/${slug}`;
            try {
                let response = await axios.get(url);
                commit('SET_BLOGS_DETAILS', response.data.data)
            } catch (errors){
                console.log(errors)
            }
        },

    //     store blogs comments
        async storeBlogComments({commit},formData) {
            const url = "/api/blog-comments";

            try {
                commit("SET_COMMENT_LOADER", true);
                const token = localStorage.getItem("token");

                let response = await axios.post(url, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (response.status === 200 && response.data.success) {
                    toast.success(response.data.success);
                    return response;
                } else {
                    toast.error(response.data.error)
                    return null;
                }
            } catch (error) {
                if (error.response && error.response.data) {
                    let message = error.response.data.message || "Failed to submit comment.";
                    console.log(message);
                    // toast.error(message);
                }
                throw error;
            } finally {
              commit("SET_COMMENT_LOADER", false);
            }
        },

        // fetch blogs comments
        async fetchBlogComments({ commit }, { id, page = 1 }) {
            // window.scrollTo(0, 0);
            const url = `/api/fetch-blog-comments/${id}?page=${page}`;

            try {
                commit('SET_BLOG_COMMENT_LOADER', true);
                const response = await axios.get(url);
                commit('SET_BLOG_COMMENT_DATA', response.data.data);
                commit('SET_PAGINATION', response.data);
            } catch (errors) {
                console.log("Error fetching comments:", errors);
            } finally {
                commit('SET_BLOG_COMMENT_LOADER', false);
            }
        },

    //     store blog replies
        async storeBlogReply({commit},formData) {
            const url = "/api/store-blog-reply";

            try {
                commit("SET_BLOG_REPLY_LOADER", true);
                const token = localStorage.getItem("token");

                let response = await axios.post(url, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (response.status === 200 && response.data.success) {
                    toast.success(response.data.success);
                    return response;
                } else {
                    toast.error(response.data.error)
                    return null;
                }
            } catch (error) {
                if (error.response && error.response.data) {
                    let message = error.response.data.message || "Failed to submit comment.";
                    console.log(message);
                    // toast.error(message);
                }
                throw error;
            } finally {
                commit("SET_BLOG_REPLY_LOADER", false);
            }
        },

    //     fetch blog categories
        async fetchBlogCategories({commit}){
            const url =  `/api/blog-categories`;
            try {
                let response = await axios.get(url);
                commit('SET_BLOG_CATEGORIES', response.data)
            } catch (errors){
                console.log(errors)
            }
        },


        async fetchMorePage({commit}, slug) {
            const url =  `/api/get-more-page/${slug}`;
            try {
                commit('SET_MORE_PAGE_LOADING', true);
                let response = await axios.get(url);
                commit('SET_MORE_PAGE', response.data.data)
            } catch (errors){
                console.log("Api ERROR (Failed to fetch morepage)", errors)
            } finally {
                commit('SET_MORE_PAGE_LOADING', false);
            }
        }

    },
};

export default websiteModule;
